import { render } from "./StepPay.vue?vue&type=template&id=6aba5cdb"
import script from "./StepPay.vue?vue&type=script&lang=js"
export * from "./StepPay.vue?vue&type=script&lang=js"

import "./StepPay.vue?vue&type=style&index=0&id=6aba5cdb&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__